export default "__VITE_ASSET__CfEW0GVx__"